import { render, staticRenderFns } from "./base-input-group-append.vue?vue&type=template&id=0162d3a8"
import script from "./base-input-group-append.vue?vue&type=script&lang=js"
export * from "./base-input-group-append.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports